const indexData = [
  { title: '看片app免费下载合集', count: 38, desc: '精选安卓与苹果端免费看片软件安装包' },
  { title: '热门影视资源索引', count: 156, desc: '按类型、地区、年份分类整理的影视目录' },
  { title: '91免费软件使用教程', count: 24, desc: '从安装到高级功能，图文视频教程全覆盖' },
  { title: '免费视频软件横评', count: 12, desc: '主流免费看片app深度对比与推荐' },
  { title: '手机看片优化技巧', count: 18, desc: '节省流量、提升画质的实用设置指南' },
  { title: '追剧日历与排期表', count: 45, desc: '热门剧集更新时间和观看渠道汇总' },
  { title: '91免费看片的app常见问题', count: 32, desc: '安装、播放、账号相关问题的解决方案' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">专题索引</h2>
          <p className="mt-2 text-sm text-foreground-500">快速找到你需要的免费看片内容与资源</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexData.slice(0, 6).map((item, i) => (
            <a
              key={i}
              href={`#index-item-${i}`}
              className="flex items-start gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all group cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                i % 3 === 0 ? 'bg-primary-100 text-primary-600' :
                i % 3 === 1 ? 'bg-accent-100 text-accent-700' :
                'bg-secondary-100 text-secondary-700'
              }`}>
                <i className={`text-lg ${
                  i === 0 ? 'ri-download-2-line' :
                  i === 1 ? 'ri-film-line' :
                  i === 2 ? 'ri-book-open-line' :
                  i === 3 ? 'ri-scales-3-line' :
                  i === 4 ? 'ri-settings-3-line' :
                  'ri-calendar-line'
                }`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">{item.title}</h3>
                  <span className="text-xs text-foreground-400 flex-shrink-0">{item.count}篇</span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-4">
          <a
            href={`#index-item-6`}
            className="flex items-center justify-between p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all group cursor-pointer"
          >
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-accent-100 text-accent-700">
                <i className="ri-question-answer-line text-lg"></i>
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{indexData[6].title}</h3>
                  <span className="text-xs text-foreground-400">{indexData[6].count}篇</span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">{indexData[6].desc}</p>
              </div>
            </div>
            <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
          </a>
        </div>
      </div>
    </section>
  );
}